<template lang="html">
  <section class="give-comment">
    <div class="tagList-select" v-if="tagList && tagList.length > 0">
      <p
        v-for="(item, index) in tagList"
        :class="{ hover: item.state }"
        @click="choose(index)"
      >
        {{ item.name }}
      </p>
    </div>
    <textarea
      class="write-comment"
      :placeholder="placeHolder"
      v-model="content"
      @input="update"
      maxlength="1000"
    ></textarea>
  </section>
</template>

<script>
export default {
  components: {},
  props: {
    tagList: {
      type: Array,
      default() {
        return []
      }
    },
    toSku: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      tag_topics: [],
      content: '',
      placeHolder: this.toSku
        ? '对这次消费满意吗？您的意见和建议是我们前进的动力'
        : '亲，你可以对Ta评价哦～'
    }
  },
  methods: {
    choose(index) {
      const item = this.tagList[index]
      item.state = !item.state
      const tag_topics = this.tag_topics
      if (item.state) {
        tag_topics.push(item.id)
      } else {
        tag_topics.splice(tag_topics.indexOf(item.id), 1)
      }
      if (this.toSku) {
        this.$store.commit('setNewComment', {
          tag_topics: tag_topics.join(',')
        })
      } else {
        this.$store.commit('setCommentObj', {
          tags: tag_topics.join(',')
        })
      }
      this.$$tracker('110802', '20000', 21067, item.name)
    },
    update(e) {
      // console.log(e)
      this.content = e.target.value
      if (this.content.length >= 1000) {
        return this.$$toast('评论请控制在1000个汉字以内哦')
      }
      if (this.toSku) {
        this.$store.commit('setNewComment', {
          content: this.content
        })
      } else {
        this.$store.commit('setCommentObj', {
          content: this.content
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../assets/css/mixin';

.give-comment {
  font-size: 0;
  background-color: #fff;
  // padding: rem(10px) rem(20px);
  .tagList-select {
    padding-left: rem(69px);
    padding-bottom: rem(30px);
    display: flex;
    flex-wrap: wrap;
    p {
      width: rem(164px);
      height: rem(60px);
      margin-bottom: rem(30px);
      margin-right: rem(36px);
      // padding: rem(9px) rem(20px);
      font-size: rem(28px);
      color: #666;
      line-height: rem(60px);
      text-align: center;
      @include border(all, #ebebeb, 1px, 30px);
      border-radius: rem(30px);
      &.hover {
        &::before {
          border: 1px solid #ff397e;
        }
      }

      &:nth-child(3n) {
        margin-right: 0;
      }
    }
  }
  .write-comment {
    // margin-top: rem(30px);
    // margin-bottom: rem(20px);
    padding: rem(20px);
    width: 100%;
    min-height: rem(188px);
    font-size: rem(28px);
    color: #121212;
    line-height: rem(44px);
    -webkit-appearance: none;
    resize: none;
    border: 1px solid #ebebeb;
    border-radius: rem(4px);
    word-break: break-all;

    &::-webkit-input-placeholder {
      color: #ccc;
      font-size: rem(28px);
      line-height: rem(44px);
    }
  }
}
</style>
